import { ReactElement } from 'react'
import { toast, ToastPosition } from 'react-toastify'

export const errorToast = (errors: string[] | ReactElement) => {
  if (!Array.isArray(errors)) {
    return toast(errors, { type: 'error' })
  }

  errors.forEach((error) => {
    toast(error, { type: 'error' })
  })
}

export const successToast = (
  msg: string | ReactElement,
  position?: ToastPosition,
  autoClose?: number,
) => {
  toast(msg, {
    type: 'success',
    position: position ?? 'bottom-center',
    style: { backgroundColor: '#0cbc8b' },
    theme: 'colored',
    autoClose: autoClose ?? 3000,
  })
}
